import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { DuplicateDeviceSignalDocument } from './duplicate.generated';

export const useDuplicateDeviceSignal = (
  options: ApiOptions<typeof DuplicateDeviceSignalDocument> = {},
) => {
  const { t } = useTranslation();
  return useMutation(DuplicateDeviceSignalDocument, {
    ...useNotifications(DuplicateDeviceSignalDocument, {
      failure: (error) => error.message || t('api.common.error_generic'),
      success: t('api.device_signals.duplicate_success'),
    }),
    ...options,
  });
};
